export enum JobBoardFilter {
  GLOBAL_EVALUATION_MEAN = 'globalEvaluationMean',
  CALCULATED_SCORE = 'calculatedScore',
  LIKE = 'appreciationMean',
}

export enum ApplicationDocumentType {
  CV = 'CV',
  COVER_LETTER = 'COVER_LETTER',
}

export enum DefaultPipeline {
  NEW = 'Nouvelle',
  REJECTED = 'Refusée',
  ACCEPTED = 'Acceptée',
}

export enum ScoringOperationStatus {
  SCORED = "SCORED",
  PENDING = "PENDING",
  FAILED = "FAILED"
}